
import Vue from 'vue'

export default Vue.extend({
  name: 'NewsItem',
  props: {
    /**
     * Объект данных новости
     */
    itemData: {
      type: Object,
      required: true,
      default: () => {}
    },
    /**
     * Получение изображения
     */
    previewImage: {
      type: Function,
      default: () => () => ''
    },
    /**
     * Получение даты публикации
     */
    getDate: {
      type: Function,
      default: () => () => ''
    }
  }
})
